export default class CustomControlbarButton {
    constructor(args) {
        this.icon = args.icon;
        this.label = args.label;
        this.onClick = args.onClick;
        this.position = args.position;
        this.attributes = args.attributes || {};
    }
    async unregister() {
        // TODO: Remove the changer from the body
    }
    addControlBarButton(selector, attributes) {
        selector.add('dyte-controlbar-button', Object.assign({ id: this.label, label: this.label, icon: this.icon, 
            // @ts-ignore
            onClick: this.onClick }, attributes));
    }
    register(config, meeting, getBuilder) {
        this.meeting = meeting;
        // Add buttons with config
        const builder = getBuilder(config);
        if (this.position === 'more-menu') {
            const lgMoreItems = builder.find('dyte-more-toggle', {
                activeMoreMenu: true,
            });
            this.addControlBarButton(lgMoreItems, {
                variant: 'horizontal',
                slot: 'more-elements',
            });
        }
        else {
            const controlBar = builder.find(`div#controlbar-${this.position}`);
            if (!controlBar)
                return config;
            this.addControlBarButton(controlBar, this.attributes);
        }
        // Add button in more menu for different screen sizes
        const mdMoreItems = builder.find('dyte-more-toggle', {
            activeMoreMenu: true,
            md: true,
        });
        this.addControlBarButton(mdMoreItems, {
            variant: 'horizontal',
            slot: 'more-elements',
        });
        const smMoreItems = builder.find('dyte-more-toggle', {
            activeMoreMenu: true,
            sm: true,
        });
        this.addControlBarButton(smMoreItems, {
            variant: 'horizontal',
            slot: 'more-elements',
        });
        // Return the updated config
        return builder.build();
    }
}
